import { action } from "satcheljs";

/**
 * Called on a category favorited
 * @param categoryId the id to be added
 */
export interface ON_CATEGORY_FAVORITEDActionMessage {
    categoryId: string;
}
export const onCategoryFavorited: (categoryId: string) => ON_CATEGORY_FAVORITEDActionMessage = action("ON_CATEGORY_FAVORITED", (categoryId: string): ON_CATEGORY_FAVORITEDActionMessage => {
    return {
        categoryId,
    };
});

/**
 * Called on a category un favorited
 * @param categoryId the id to be added
 */
export interface ON_CATEGORY_UNFAVORITEDActionMessage {
    categoryId: string;
}
export const onCategoryUnfavorited: (categoryId: string) => ON_CATEGORY_UNFAVORITEDActionMessage = action("ON_CATEGORY_UNFAVORITED", (categoryId: string): ON_CATEGORY_UNFAVORITEDActionMessage => {
    return {
        categoryId,
    };
});
